angular.module('ContactDetailsAddReqsModule', [])
    .controller('AddToReqController', ['$scope', '$rootScope', 'TemplateLoader',
        function ($scope, $rootScope, TemplateLoader) {
            //Setting up add to Req modal configs

            $scope.templates = TemplateLoader.register({
                addToReq: window.jvUrls.jhire + '/modules/candidates/modals/addToReq.html'
            });
            var getmodalConfig = function () {
                //Add to Req modal config
                $scope.addToReqModalConfig = {
                    resetModalOn: 'modals.addToReq.show',
                    list: {
                        config: {
                            type: 'multiSelect',
                            keyName: 'selectedReqEId',
                            label: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_SELECT_REQUISITION'],
                            tooltip: {
                                show: false,
                                text: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_TOOLTIP_TEXT_GOES_HERE']
                            },
                            required: true,
                            errorText: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_PLEASE_SELECT_A_REQUISITION'],
                            emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                            columns: [{
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_REQUISITION'],
                                show: true,
                                key: ['title'],
                                ellipsis: {
                                    set: true
                                }
                            }, {
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_ID'],
                                show: true,
                                key: ['requisitionId'],
                                ellipsis: {
                                    set: true
                                }
                            }, {
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_STATUS'],
                                show: true,
                                key: ['jobState'],
                                ellipsis: {
                                    set: true
                                }
                            }, {
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_COMPANY'],
                                show: 'showCompany',
                                key: ['subsidiary.name'],
                                ellipsis: {
                                    set: true
                                }
                            }, {
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_CATEGORY'],
                                show: true,
                                key: ['category.name'],
                                ellipsis: {
                                    set: true
                                }
                            }, {
                                header: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_LOCATION'],
                                show: true,
                                key: ['location.name'],
                                ellipsis: {
                                    set: true
                                },
                                tooltipShow: 'jobLocations',
                                tooltipTriggerLength: 'jobLocations',
                                tooltipTriggerClass: 'italic',
                                tooltipBodyList: 'jobLocations',
                                tooltipBodyListId: ['name']
                            }]
                        },
                        get: $scope.listGetObject,
                        post: {
                            callBack: $scope.addToReqCallback,
                            button: {
                                label: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_SELECT'],
                                type: 'button',
                                classNames: ['blue-btn', 'float-right'],
                                id: 'addToReq-btn'
                            }
                        },
                        filters: [{
                                label: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_STATUS'],
                                ghostText: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_ALL'],
                                width: 'w160',
                                allowClear: true,
                                data: $scope.statusFilter,
                                keyName: 'reqsStatusFilter',
                                defaultTo: (JSON.stringify({
                                    key: 1,
                                    mine: false,
                                    name: i18n["JV_CONTACTS_ADDTOREQ_CONTROLLER_OPEN"]
                                }))
                            }, {
                                label: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_CATEGORIES'],
                                ghostText: i18n['JV_CONTACTS_ADDTOREQ_CONTROLLER_ALL'],
                                width: 'w260',
                                allowClear: true,
                                data: $scope.categoriesFilter,
                                keyName: 'reqsCategoryFilter'
                                //responseKey: 'filters.Categories'
                            }

                        ],
                        search: {
                            label: i18n['JV_ADDTOREQ_CONTROLLER_SEARCH'],
                            placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                            get: {
                                url: '/jhire/action/requisitions?'
                            }
                        }
                    }
                };
                return $scope.addToReqModalConfig;
            };

            var setupFormTemplateConfig = function (action) {
                $scope.listGetObject = {
                    url: '/jhire/action/requisitions?',
                    params: {
                        page: '0',
                        q: '',
                        maxResults: '10',
                        mine: false
                    },
                    responseKey: 'jobs'
                };
                $scope.formTemplateConfig = getmodalConfig(action);
            };

            $rootScope.$on('AddToRequisitionModal', function (args, results) {
                $scope.statusFilter = results.allStatusFilter.optionValues;
                $scope.categoriesFilter = results.filters.Categories;
                setupFormTemplateConfig('addToReq');
                TemplateLoader.load('addToReq').then(function () {
                    $scope.modals.addToReq.show = true;
                });
            });



            $scope.addToReqCallback = function (data) {
                $rootScope.$broadcast('REQUISITTION_SELECTED_ID', data);
            };

            $scope.close = function () {
                $scope.modals.addToReq.show = false;
            };
            $scope.flags = {};
        }
    ]);